"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _Link = require("../../../elements/link/Link");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _navLinkModule = _interopRequireDefault(require("./nav-link.module.scss"));
var NavLink = function NavLink(_ref) {
  var _classnames;
  var children = _ref.children,
    href = _ref.href,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    active = _ref.active,
    notificationCount = _ref.notificationCount,
    external = _ref.external,
    target = _ref.target;
  return /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: onClick,
    className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, _navLinkModule.default['link-item'], true), (0, _defineProperty2.default)(_classnames, _navLinkModule.default.active, active), _classnames)),
    external: external,
    target: target
  }, children, notificationCount && /*#__PURE__*/_react.default.createElement("div", {
    className: _navLinkModule.default['notification-count']
  }, notificationCount));
};
exports.NavLink = NavLink;